module.exports = __webpack_public_path__ + "img/news-pic-xl.da56e4e1.png";